import React from "react";

export default function Input({
  className = "",
  ...rest
}: React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...rest}
      className={`w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm outline-none
                 placeholder:text-gray-400 focus:border-sky-500 focus:ring-2 focus:ring-sky-500/20 ${className}`}
    />
  );
}
